module.exports = __webpack_public_path__ + "img/default_avatar.db035160.jpg";